import {Component, OnInit, ViewChild} from '@angular/core';
import {TemplateService} from '../../services/template.service';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-tax-report',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss'],
  providers: [TemplateService]
})

export class SettingsComponent implements OnInit {

  autoSend = true;
  manualSendDay = 15;

  modal: NgbModalRef;
  selectedValue = '';
  confirmPassword = '';
  passwordErrorMessage: string = null;
  updateSettingsMessage: string = null;

  constructor(private apiService: ApiService,
              private modalService: NgbModal,
              private router: Router,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.getSettings();
  }

  getSettings() {
    this.apiService.getSettings().subscribe(
      (result) => {

        // check that result is not empty
        if (Object.keys(result).length !== 0 || result.constructor !== Object) {
          this.autoSend = result.auto_send.is_active;
          this.manualSendDay = result.auto_send.default_send_date;

          if (this.autoSend === false) {
            this.selectedValue = 'manualSend';
            (document.getElementById('manualSendDaySelectBox') as HTMLButtonElement).disabled = false;
          } else {
            this.selectedValue = 'autoSend';
            (document.getElementById('manualSendDaySelectBox') as HTMLButtonElement).disabled = true;
          }
        }

      },
      error => {

      }
    );
  }

  save(content) {
    this.confirmPassword = '';
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
  }

  cancel() {
    this.confirmPassword = '';
    this.router.navigate(['/dashboard']);
  }

  closeConfirmSettingsBox() {
    this.modal.close();
  }

  confirmSaveSettingsBox(content) {
    // close save settings box
    this.modal.close();

    // open confirm save settings box
    this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});
  }

  closePasswordBox() {
    this.modal.close();
  }

  enterPasswordBox(content) {
    this.passwordErrorMessage = null;

    this.apiService.confirmPassword({
      confirm_password: this.confirmPassword,
    }).subscribe(
      (result) => {
        if (result.success === true) {
          this.updateSettingsHelper(content);
        } else {
          if (this.translate.currentLang === 'en') {
            this.passwordErrorMessage = 'Password is incorrect';
          } else {
            this.passwordErrorMessage = 'รหัสผ่านไม่ตรงกัน';
          }
        }
      },
      error => {
        if (this.translate.currentLang === 'en') {
          this.passwordErrorMessage = 'Password is incorrect';
        } else {
          this.passwordErrorMessage = 'รหัสผ่านไม่ตรงกัน';
        }
      }
    );
  }

  closeSavedSuccessfullyBox() {
    this.confirmPassword = '';
    this.modal.close();
  }

  updateSettingsHelper(content) {

    this.updateSettingsMessage = null;

    if (this.selectedValue === 'manualSend') {
      this.autoSend = false;
    } else if (this.selectedValue === 'autoSend') {
      this.autoSend = true;
    }

    const params = {
      autoSend: this.autoSend,
      manualSendDay: this.manualSendDay
    };

    this.apiService.updateSettings(params).subscribe(
      (result) => {
        if (this.translate.currentLang === 'en') {
          this.updateSettingsMessage = 'Saved successfully!';
        } else {
          this.updateSettingsMessage = 'บันทึกสำเร็จ';
        }
        // close password box
        this.modal.close();

        // open update settings status box
        this.modal = this.modalService.open(content, {backdrop: 'static', keyboard: false, centered: true});

      },
      error => {
        if (this.translate.currentLang === 'en') {
          this.updateSettingsMessage = 'Settings not saved';
        } else {
          this.updateSettingsMessage = 'บันทึกไม่สำเร็จ';
        }

      }
    );
    this.sniff('UPDATE_SETTINGS', 'autoSend: ' + params.autoSend
      + ', manualSendDay: ' + params.manualSendDay);
  }

  onItemChange() {
   if (this.selectedValue === 'autoSend') {
     (document.getElementById('manualSendDaySelectBox') as HTMLButtonElement).disabled = true;
   } else if (this.selectedValue === 'manualSend') {
     (document.getElementById('manualSendDaySelectBox') as HTMLButtonElement).disabled = false;
   }
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'SETTINGS',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/settings/settings.component.ts